import React, { useState } from "react";
import { LTabStrip } from "@loffa/gpp-modules";
import { Automation } from "./Automation/Automation";

function DatamanagerManagement() {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div>
      <LTabStrip
        selected={selectedTab}
        onSelect={(e) => setSelectedTab(e.selected)}
        tabs={[
          {
            title: "Automation",
            body: <Automation />,
          }
        ]}
      />
    </div>
  );
}

export { DatamanagerManagement };
